// extracted by mini-css-extract-plugin
module.exports = {"container":"NetworkStartsStreamsContainer_container__2H3NV","description":"NetworkStartsStreamsContainer_description__2AjAX"};